import React, { useEffect, useState } from "react";
import { Button } from "@/components/ui/button";
import { Label } from "@/components/ui/label";
import { Slider } from "@/components/ui/slider";
import { Switch } from "@/components/ui/switch";
import { Popover, PopoverContent, PopoverTrigger } from "@/components/ui/popover";
import { StrengthMeter } from "./StrengthMeter";
import { generatePassword } from "@/lib/vaultCrypto";
import { RefreshCw, Wand2 } from "lucide-react";

export const PasswordGenerator = ({ onUse, trigger }) => {
  const [open, setOpen] = useState(false);
  const [opts, setOpts] = useState({ length: 20, upper: true, digits: true, symbols: true, avoidAmbiguous: false });
  const [pw, setPw] = useState("");

  useEffect(() => {
    if (open) setPw(generatePassword(opts));
  }, [open, opts]);

  return (
    <Popover open={open} onOpenChange={setOpen}>
      <PopoverTrigger asChild>
        {trigger || <Button type="button" variant="outline" size="sm" data-testid="generator-open-button"><Wand2 className="h-4 w-4 mr-1.5" /> Generer</Button>}
      </PopoverTrigger>
      <PopoverContent align="end" className="w-80 bg-card space-y-4" data-testid="generator-popover">
        <div className="flex items-center gap-2 rounded-lg border bg-secondary/60 px-3 py-2">
          <code className="flex-1 text-sm break-all font-mono" data-testid="generator-value">{pw}</code>
          <Button type="button" variant="ghost" size="icon" className="h-8 w-8 shrink-0" onClick={() => setPw(generatePassword(opts))} aria-label="Generer nytt" data-testid="generator-refresh"><RefreshCw className="h-4 w-4" /></Button>
        </div>
        <StrengthMeter password={pw} testId="generator-strength" />
        <div className="space-y-2">
          <div className="flex items-center justify-between text-sm"><Label>Lengde</Label><span className="tnum text-muted-foreground">{opts.length}</span></div>
          <Slider value={[opts.length]} min={8} max={64} step={1} onValueChange={([v]) => setOpts((o) => ({ ...o, length: v }))} data-testid="generator-length" />
        </div>
        {[["upper", "Store bokstaver"], ["digits", "Tall"], ["symbols", "Symboler"], ["avoidAmbiguous", "Unngå lett forvekslede tegn (Il1O0)"]].map(([k, label]) => (
          <label key={k} className="flex items-center justify-between text-sm"><span>{label}</span><Switch checked={!!opts[k]} onCheckedChange={(v) => setOpts((o) => ({ ...o, [k]: v }))} data-testid={`generator-${k}`} /></label>
        ))}
        <Button type="button" className="w-full" onClick={() => { onUse(pw); setOpen(false); }} data-testid="generator-use-button">Bruk dette passordet</Button>
      </PopoverContent>
    </Popover>
  );
};
